import { render } from "./statistics.vue?vue&type=template&id=0201cd34&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=0201cd34&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0201cd34"]])

export default __exports__